import { Component, OnInit, OnDestroy,} from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { EssencialService } from '../../services/essencial.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { buttons, mensajes } from '../../../../../assets/data/diccionario.js';
import { essencialModul } from '../../diccionarios/essencialModulo';
import { from, Subscription } from 'rxjs';


@Component({
  selector: 'app-mantener-jerarquia-essencial',
  templateUrl: './mantener-jerarquia-essencial.component.html',
  styleUrls: ['./mantener-jerarquia-essencial.component.css']
})

export class MantenerJerarquiaEssencialComponent implements OnInit {

  public DAT_TITULOS = essencialModul.titulos;
  public DAT_AG_GRID = essencialModul.agGrid;
  public DAT_BTNCSS  = buttons;
  public MENS_STANDAR= mensajes;

  public titleModal  : string;
  public loading     : boolean = false;
  public isCreate    : boolean = true;
  public isAsignar   : boolean = false;

  public frameworkComponents: any;
  public columnDefs  : any[] = [];
  public rowData     : any[] = [];
  public gridApi     : any;
  public gridColumnApi: any;

  public comboUnegocio: any[] = [];
  public comboCanal   : any[] = [];
  public comboSubCanal: any[] = [];
  public comboGPrecios: any[] = [];

  public jeraquiaSuperior: any;

  public formulario = new FormGroup({
    nivel         : new FormControl(1, [Validators.required]),
    unidadNegocio : new FormControl('', [Validators.required]),
    canal         : new FormControl('', [Validators.required]),
    subCanal      : new FormControl(''),
    superior      : new FormControl(''),
  });

  public formDetalle = new FormGroup({
    nivel         : new FormControl(3, [Validators.required]),
    unidadNegocio : new FormControl('', [Validators.required]),
    canal         : new FormControl('', [Validators.required]),
    subCanal      : new FormControl('', [Validators.required]),
    grupoPrecios  : new FormControl('', [Validators.required]),
    superior      : new FormControl(),
  });

  constructor(
    private essecialServices: EssencialService,
    private utilServices    : UtilsService,
    private dmaestroServices: DatosMaestrosService,
  ) { }

  ngOnInit(): void {
    this.inicializaCombos();
    this.gridComponent();
    this.listar();

    console.log("Modo del Formularios en Inicializar ", this.isCreate);

  }

  gridComponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [
      { filter: true, resizable: true, width: 100, field: 'nivel'},
      { filter: true, resizable: true, width: 100, field: 'padre', sort: 'asc', headerName:"Unidad Negocio"},
      { filter: true, resizable: true, field: 'dscaPadre', headerName:"Unidad Negocio"},
      { filter: true, resizable: true, width: 100, field: 'hijo', headerName:"Canal", sort: 'asc'},  
      { filter: true, resizable: true, field: 'dscaHijo', headerName:"Canal"},
      { filter: true, resizable: true, width: 100, field: 'subCanal'},  
      { filter: true, resizable: true, field: 'dscaSubCanal', headerName:"subCanal"},
      { cellRenderer: 'buttonRenderer', headerName: 'Clasificar Canal/Subcanal', 
        cellRendererParams: {
          onClick: this.clasificar.bind(this),
          label: 'Editar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-edit'
        },
      },
      { cellRenderer: 'buttonRenderer', headerName: 'Eliminar',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-trash'
        },
      }
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar(){
    this.rowData =[];
    this.essecialServices.getAllNivel_2().subscribe((res) => {
      if(res.length > 0){
        this.rowData = res;
      }else{
        this.utilServices.mensajeOKToast("No se encontraron regitros", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.DAT_TITULOS.tituloAgregar;
    this.formulario.reset();
    this.formulario.get('nivel').setValue(1);
    this.formulario.get('subCanal').setValidators([]);
    this.formulario.get('subCanal').updateValueAndValidity();
    this.openModal();
    console.log("Modo del Formularios en nuevo", this.isCreate);
  }

  editar({rowData}){
    if(rowData.nivel == 2) return;
    this.isCreate   = false;
    this.titleModal = this.DAT_TITULOS.tituloActualizar;
    this.formulario.reset();

    this.formulario.get('nivel').setValue(2);
    this.formulario.get('unidadNegocio').setValue(rowData.padre);
    this.formulario.get('canal').setValue(rowData.hijo);
    this.formulario.get('superior').setValue(rowData.idJerarquia);

    this.formulario.get('subCanal').setValidators([Validators.required]);
    this.formulario.get('subCanal').updateValueAndValidity();

    this.openModal();
  }


  clasificar({rowData}){
    
    if(rowData.nivel == 1){
      this.editar({rowData});
      return;
    };

    this.isAsignar  = true;
    this.titleModal = this.DAT_TITULOS.tituloActualizar;

    this.jeraquiaSuperior = rowData.idJerarquia;
    console.log("Objeto a clasificar ", rowData);

    this.formDetalle.reset();
    this.formDetalle.patchValue(rowData);    
    this.formDetalle.get('nivel').setValue(3);
    this.formDetalle.get('superior').setValue(rowData.idJerarquia);
    
    this.listarClasificacion(this.jeraquiaSuperior);

    this.columnDefs = [
      { filter: true, resizable: true, field: 'nivel'},
      { filter: true, resizable: true, field: 'padre', headerName: 'SubCanal'},
      { filter: true, resizable: true, field: 'dscaPadre', headerName: 'Nombre SubCanal'},
      { filter: true, resizable: true, field: 'hijo', headerName: 'Grupo Precios'},
      { filter: true, resizable: true, field: 'dscaHijo', headerName: 'Nombre Grupo Precios'},
      { cellRenderer: 'buttonRenderer', headerName: 'Eliminar',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-trash'
        },
      }
    ];


  }

  listarClasificacion(idJerarquia){
    this.rowData =[];

    this.essecialServices.getAllNivel(3, idJerarquia).subscribe((res) => {
      if(res.length > 0){
        this.rowData = res;
      }else{
        this.utilServices.mensajeOKToast("No se encontraron regitros", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  eliminar({rowData}){
    this.loading = true;
    console.log('Eliminar => ', rowData);

    this.utilServices.confirmarSincronoPromesa({
        title : this.MENS_STANDAR.eliminar,
        text  : this.DAT_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.essecialServices.eliminar(rowData.idJerarquia),
      })
      .then((_res: any) => {
        if(this.isAsignar){
          this.listarClasificacion(this.jeraquiaSuperior);
        }else{
          this.listar();
        }        
      })
      .catch(() => {
      });
    
    this.loading = false;
  }

  saveForm() {
    let mensajeP = this.isCreate ? this.MENS_STANDAR.guardar : this.MENS_STANDAR.actualizar;
    let items  = this.formulario.getRawValue();
    
    console.log("objeto a crear formulario", items);

    items.padre = items.unidadNegocio;
    items.hijo = items.canal;

    if(!this.isCreate){
      items.padre = items.canal;
      items.hijo = items.subCanal;
    }

    if(this.isAsignar){
      items  = this.formDetalle.getRawValue();
      items.padre = items.subCanal;
      items.hijo = items.grupoPrecios;
    }

    console.log("objeto a crear", items);
    console.log("objeto a crear formulario SubCalsificaciones", this.rowData);

    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.essecialServices.create(items),
        //this.isCreate ? this.essecialServices.create(items) : this.essecialServices.update(items  ),
      })
      .then(() => {
        if(this.isAsignar){ 
          this.listarClasificacion(this.jeraquiaSuperior);
        }else{
          this.listar();
        }        
        this.closeModal();
      })
      .catch(() => {
      });

      this.loading = false;
  }

  acciones(event) {
    console.log("evento del clic", event);
    if (event === 'regresar') return this.closeModal();
    if (this.formulario.invalid) return;
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }


  returnNivel_1(): void {
    this.isAsignar = false;
    this.loading = true;
    this.gridComponent();
    this.listar();
    this.loading = false;
  }


  inicializaCombos(){
    this.loading  = true;
    this.comboUnegocio =[];
    this.comboCanal    = [];
    this.comboSubCanal = [];
    this.comboGPrecios = [];

    //Unidad de negocio
    this.dmaestroServices.getAllUnidadNegocio().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.descCorta = e.idUnidad +" - "+e.descCorta;
          return e;          
        });
        this.comboUnegocio = response;
        console.log(this.comboUnegocio);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    //Canal Vendedor
    this.dmaestroServices.getAllCanalVendedor().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.descCorta = e.idCanal +" - "+e.descCorta;
          return e;          
        });
        this.comboCanal = response;
        console.log(this.comboCanal);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    //Grupo Cliente - grupo precios
    this.dmaestroServices.getAllGrupoCliente().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.dscaGrupoCliente = e.idGrupoCliente +" - "+e.dscaGrupoCliente;
          return e;          
        });
        this.comboGPrecios = response;
        console.log(this.comboGPrecios);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    //Grupo tarifa canal - subcanal
    this.dmaestroServices.getAllGrupoTarifaCanal().subscribe((response) => {
      if(response.length > 0){
        this.comboSubCanal = response;
        console.log(this.comboGPrecios);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    this.loading = false;
  }


  agregarDetalle(){
    if (this.formDetalle.invalid) return;
    this.saveForm();
  }


}